// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"21668ab0","294":"051d2380","620":"4e463a22","713":"adde154d","888":"ca410f02","976":"1952f2c9","977":"ec692162"}[chunkId] + ".chunk.js";
};